module.exports = __webpack_public_path__ + "static/media/portfolio.555ec3dd.png";